import {Col, Row} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import {useTekstClient} from "hooks/useTekstClient";
import {useSetSearchParams} from "hooks/useSetSearchParams";
import {useSearchParams} from 'next/navigation'
import useGebruiker from "../../../../hooks/useGebruiker";

const FilterBookmarked = () => {
    const {ingelogdeGebruiker} = useGebruiker()
    const {tekst, isLoadingTekst} = useTekstClient()
    const searchParams = useSearchParams()
    const {deleteParam, updateParam} = useSetSearchParams()

    const handleParams = (boolean) => {
        boolean && !searchParams.get('fav') && updateParam('fav', true)
        !boolean && searchParams.get('fav') && deleteParam('fav')
    }


    //TODO:fixen
    // useEffect(() => {
    //     mijnFavorieten(!!searchParams.get('fav'))
    // }, [searchParams.get('fav')])


    return <>
        {ingelogdeGebruiker &&
                <Row className={'ml-1'}>
                    <Col>
                        <Form.Check
                            className={`cursor-pointer`}
                            type={'checkbox'}
                            id={`bookmark-1`}
                            checked={!!searchParams.get('fav')}
                            label={tekst('pagina:support:kenniscentrum:Mijn favorieten:titel')}
                            onChange={(e) => {
                                handleParams(e.target.checked)
                            }}
                        />
                    </Col>
                </Row>
        }
    </>

}
export default FilterBookmarked;